// extracted by mini-css-extract-plugin
module.exports = {"box":"Creditbox_box__umcc4","time":"Creditbox_time__AJpHF","subtitle":"Creditbox_subtitle__y1PzF","title":"Creditbox_title__ppnuH"};